import * as yup from 'yup'

/** Схема формы ввода email без согласий (логин существующего юзера и привязка). */
export const emailOnlySchema = yup.object({
  email: yup
    .string()
    .trim()
    .lowercase()
    .email('Invalid email')
    .required('Enter your email')
})

/** Схема регистрации: email + 3 чекбокса (оферта и ПД обязательные, реклама — нет). */
export const registrationSchema = yup.object({
  email: yup
    .string()
    .trim()
    .lowercase()
    .email('Invalid email')
    .required('Enter your email'),
  agreedOffer: yup
    .boolean()
    .oneOf([true], 'You must accept the Terms of Service')
    .required(),
  agreedPersonalData: yup
    .boolean()
    .oneOf([true], 'You must consent to the processing of personal data')
    .required(),
  agreedAds: yup.boolean().required()
})

export type EmailOnlyValues = yup.InferType<typeof emailOnlySchema>
export type RegistrationValues = yup.InferType<typeof registrationSchema>
